export default __webpack_public_path__ + "static/media/bar_image.3517a041.png";